import { sectionIDs } from '../../../constants/section-ids.constants';

interface BillingViewProps {
  username: string;
}

export const BillingView = (props: BillingViewProps) => {
  const { username } = props;
  return (
    <section id={sectionIDs.BILLING_VIEW}>
      <div>Billing view for username: {username}</div>
    </section>
  );
};
